import {
  loadUser,
  updateBlacklist,
  addToBlacklist,
  removeFromBlacklist,
  loadTeams,
} from '../services/api/webex';
import actionTypes from './action_types';

export function loadWebexUser() {
  return (dispatch) => {
    return loadUser().then(({ user }) => (
      dispatch({
        type: actionTypes.WEBEX_USER_LOADED,
        payload: { user },
      })
    ));
  };
}

export function loadWebexTeams() {
  return (dispatch) => {
    return loadTeams().then(({ teams }) => (
      dispatch({
        type: actionTypes.WEBEX_CHANNELS_LOADED,
        payload: { teams },
      })
    ));
  };
}

export function loadWebexUserData() {
  return (dispatch, getState) => {
    return dispatch(loadWebexUser())
      .then(() => {
        if (getState().webex.user) {
          dispatch(loadWebexTeams());
        }
      });
  };
}

export function updateWebexBlacklist({ removeIds = [], addIds = [] }) {
  return (dispatch) => {
    return updateBlacklist({ removeIds, addIds })
      .then(teams => (
        dispatch({
          type: actionTypes.WEBEX_CHANNELS_UPDATED,
          payload: { teams },
        })
      ));
  };
}

export function addToWebexBlacklist(channelId, teamId) {
  return (dispatch) => {
    return addToBlacklist({ channelId })
      .then(() => (
        dispatch({
          type: actionTypes.WEBEX_CHANNEL_ADDED_TO_BLACKLIST,
          payload: { channelId, teamId },
        })
      ));
  };
}

export function removeFromWebexBlacklist(channelId, teamId) {
  return (dispatch) => {
    return removeFromBlacklist({ channelId })
      .then(() => (
        dispatch({
          type: actionTypes.WEBEX_CHANNEL_REMOVED_FROM_BLACKLIST,
          payload: { channelId, teamId },
        })
      ));
  };
}




// WEBPACK FOOTER //
// ./src/actions/webex.js